import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  getParentalConsentItemByID,
  isParentalConsentSaving
} from "state/school_money/selectors";
import { updateParentalConsent } from "state/school_money/actions";

import Card from "components/Card";
import Date from "components/Date";
import Checkbox from "components/Checkbox";
import Spinner from "components/Spinner";

import "./ParentalConsentItem.css";

class ParentalConsentItem extends React.Component {

  onChange = checked => {
    this.props.update(checked)
  }

  render() {
    const { item, isSaving } = this.props;
    const { description, dueDate, isGiven } = item;
    return (
      <Card>
        <Card.Body>
          <div className="parental-consent-item">
            <div className="parental-consent-item__details">
              <div className="parental-consent-item__description">{description}</div>
              <div className="parental-consent-item__due-date"><Date date={dueDate} /></div>
            </div>
            <div className="parental-consent-item__checkbox-container">
              {
                isSaving ?
                <Spinner color="school_money" /> :
                <Checkbox
                  cssModifier="school_money"
                  checked={isGiven}
                  disabled={isGiven}
                  onChange={this.onChange}
                />
              }
            </div>
          </div>
        </Card.Body>
      </Card>
    );
  }

}

export default connect(
  (state, { itemID }) => ({
    item: getParentalConsentItemByID(state, itemID),
    isSaving: isParentalConsentSaving(state, itemID)
  }),
  (dispatch, { itemID }) => bindActionCreators({
    update: checked => updateParentalConsent(itemID, checked)
  }, dispatch)
)(ParentalConsentItem);



// WEBPACK FOOTER //
// ./src/components/school_money/parental_consent/ParentalConsentItem.js